import React, { useEffect, useState } from "react";
import InputComponent from "../../components/Input";
import ButtonComponent from "../../components/Button";
import SelectDropdown from "../../components/SelectDropdown";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { AddCouponAction } from "../../store/actions/user-action";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useSelector } from "react-redux";

const AddCoupon = () => {
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const userRole = useSelector(
    (state) => state.userDetails?.userInfo?.userResponse?.role
  );

  useEffect(() => {
    if (userRole === "superAdmin") {
      setDropdownOptions([{ value: "admin", label: "Admin" }]);
    } else if (userRole === "admin") {
      setDropdownOptions([
        { value: "vendor", label: "Vendor" },
        { value: "driver", label: "Driver" },
      ]);
    }
  }, [userRole]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    couponCode: Yup.string().required("Coupon Code is required"),
    couponType: Yup.string()
      .oneOf(["percentage", "amount"])
      .required("Coupon Type is required"),
    value: Yup.number()
      .required("Value is required")
      .when("couponType", {
        is: "percentage",
        then: (schema) => schema.max(90, "Maximum percentage value is 90"),
        otherwise: (schema) => schema.max(250, "Maximum amount value is 250"),
      }),
    usageCondition: Yup.object({
      minCartValue: Yup.number()
        .min(0, "Minimum cart value must be at least 0")
        .required("Minimum cart value is required"),
      validTimes: Yup.number().required("Valid Times value is required"),
      minShoeCount:Yup.number().optional()
    }),
    categoryId: Yup.string()
      .matches(/^[a-f\d]{24}$/i, "Category ID must be a valid 24-character hex string")
      .optional(),
    expiresAt: Yup.string().optional(),
  });
  
  
  
  const formik = useFormik({
    initialValues: {
      couponCode: "",
      couponType: "percentage",
      hideCoupon: false,
      value: "",
      usageCondition: {
        minCartValue: 0,
        minShoeCount:0,
      },
      mobileNumber: "",
      categoryId: "",
      expiresAt: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(AddCouponAction(values, formik));
    },
  });

  return (
    <div className="p-[25px] rounded-md border bg-white">
      <h3 className="font-medium">Add New Coupon</h3>
      <form className="mt-5" onSubmit={formik.handleSubmit}>
        <div className="flex space-x-8">
          {/* Left Column */}
          <div className="w-1/2">
            {/* Coupon Code */}
            <label className="block text-sm font-medium text-gray-900">
              Coupon Code
            </label>
            <InputComponent
              type="text"
              name="couponCode"
              placeholder="Enter coupon code"
              value={formik.values.couponCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.couponCode && formik.errors.couponCode}
            />
            {formik.touched.couponCode && formik.errors.couponCode && (
              <div className="text-red-500 text-sm">
                {formik.errors.couponCode}
              </div>
            )}

            {/* Mobile Number */}
            <label className="block text-sm font-medium text-gray-900 mt-4">
              Mobile Number
            </label>
            <InputComponent
              type="text"
              name="mobileNumber"
              placeholder="Enter mobile number"
              value={formik.values.mobileNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {/* Minimum Cart Value */}
            <label className="block text-sm font-medium text-gray-900 mt-4">
              Minimum Cart Value
            </label>
            <InputComponent
              type="number"
              name="usageCondition.minCartValue"
              placeholder="Enter minimum cart value"
              value={formik.values.usageCondition.minCartValue}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.usageCondition?.minCartValue &&
                formik.errors.usageCondition?.minCartValue
              }
            />

             {/* Minimum Cart Value */}
             <label className="block text-sm font-medium text-gray-900 mt-4">
              Minimum Shoe Count
            </label>
            <InputComponent
              type="number"
              name="usageCondition.minShoeCount"
              placeholder="Enter minimum Shoe count"
              value={formik.values.usageCondition.minShoeCount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.usageCondition?.minShoeCount &&
                formik.errors.usageCondition?.minShoeCount
              }
            />
            {formik.touched.usageCondition?.minShoeCount &&
              formik.errors.usageCondition?.minShoeCount && (
                <div className="text-red-500 text-sm">
                  {formik.errors.usageCondition.minShoeCount}
                </div>
              )}
            {/* ValidTimes Cart Value */}
            <label className="block text-sm font-medium text-gray-900 mt-4">
              Valid Times
            </label>
            <InputComponent
              type="number"
              name="usageCondition.validTimes"
              placeholder="Enter valid Times value"
              value={formik.values.usageCondition.validTimes}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.usageCondition?.validTimes &&
                formik.errors.usageCondition?.validTimes
              }
            />
            {formik.touched.usageCondition?.validTimes &&
              formik.errors.usageCondition?.validTimes && (
                <div className="text-red-500 text-sm">
                  {formik.errors.usageCondition.validTimes}
                </div>
              )}
          </div>

          {/* Right Column */}
          <div className="w-1/2">
            {/* Coupon Type */}
            <label className="block text-sm font-medium text-gray-900">
              Coupon Type
            </label>
            <SelectDropdown
              name="couponType"
              options={[
                { value: "percentage", label: "percentage" },
                { value: "amount", label: "amount" },
              ]}
              placeholder="Choose Coupon Type"
              value={formik.values.couponType}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.couponType && formik.errors.couponType}
              isDisabled
            />

            {/* Coupon Value */}
            <label className="block text-sm font-medium text-gray-900 mt-4">
              Coupon Value
            </label>
            <InputComponent
              type="number"
              name="value"
              placeholder="Enter coupon value"
              value={formik.values.value}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.value && formik.errors.value}
            />
            {formik.touched.value && formik.errors.value && (
              <div className="text-red-500 text-sm">{formik.errors.value}</div>
            )}

            {/* Expiry Date */}
            <label className="block text-sm font-medium text-gray-900 mt-4">
              Expiry Date
            </label>
            <InputComponent
              type="date"
              name="expiresAt"
              value={formik.values.expiresAt}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.expiresAt && formik.errors.expiresAt}
            />
            {formik.touched.expiresAt && formik.errors.expiresAt && (
              <div className="text-red-500 text-sm">
                {formik.errors.expiresAt}
              </div>
            )}

            {/* Category ID */}
            <label className="block text-sm font-medium text-gray-900 mt-4">
              Category ID
            </label>
            <InputComponent
              type="text"
              name="categoryId"
              placeholder="Enter category ID"
              value={formik.values.categoryId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.categoryId && formik.errors.categoryId}
            />
            {formik.touched.categoryId && formik.errors.categoryId && (
              <div className="text-red-500 text-sm">
                {formik.errors.categoryId}
              </div>
            )}
          </div>
        </div>

        {/* One-time Use Checkbox */}
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-900">
            Make it Special (Hide)
          </label>
          <input
            type="checkbox"
            name="hideCoupon"
            checked={formik.values.hideCoupon}
            onChange={(e) =>
              formik.setFieldValue("hideCoupon", e.target.checked)
            }
          />
        </div>

        {/* Submit Button */}
        <div className="mt-5 text-right">
          <ButtonComponent
            text="Add New Coupon"
            disabled={!formik.isValid || formik.isSubmitting}
          />
        </div>
      </form>
    </div>
  );
};

export default React.memo(AddCoupon);
